import { fbAppConfigs } from 'project/appConfigs';
import { updateNotificationsDirect } from '../firestoreData/notifications/notificationsData';
import { callFunctionDirect } from "./fbAll";

export const _allowNotificationSend = true

const notificationGenericTypes = {
  notificationGeneric: 'notificationGeneric',
}

export const notificationFunctionTypes = {
  addTopicGroups: 'addTopicGroups',
  addTopicToFcmTokens: 'addTopicToFcmTokens',
  getClientTopics: 'getClientTopics',
  removeTokensFromTopics: 'removeTokensFromTopics',
  sendCustomEmail: 'sendCustomEmail',
  sendCustomTokenEmail: 'sendCustomTokenEmail',
  sendGenericPush: 'sendGenericPush',
  sendFcmPayload: 'sendFcmPayload',
  sendLinkEmail: 'sendLinkEmail',
  sendNotificationByData: 'sendNotificationByData',
  sendScheduledNotifications_gcs_direct: 'sendScheduledNotifications_gcs_direct',
  sendSms: 'sendSms',
  subscribeToTopic: 'subscribeToTopic',
}

export const notificationMethodTypes = {
  firebaseApi: 'firebaseApi',
  fetch: 'fetch',
  correspond: 'correspond',
}

/**
 * 
 * @param {object} callData 
 * @returns - The `data` object {success,result, error}
 */
const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(notificationGenericTypes.notificationGeneric, callData)
  return data
}

export const fsfn_notifications = (fsCall, database_fns) => ({
  addTopicGroups: (appProfileData, unsubscribe, logging) => fsfn_addTopicGroups(fsCall, appProfileData, unsubscribe, logging),
  addTopicToFcmTokens: (fcmTokens, topic, unsubscribe, pathViews, useEventKey) => fsfn_addTopicToFcmTokens(fsCall, fcmTokens, topic, unsubscribe, pathViews, useEventKey),
  checkNotification_direct: (testOnly) => fsfn_checkNotification_direct(testOnly),
  getClientTopics: (data) => fsfn_getClientTopics(fsCall, data),
  removeTokensFromTopics: (fcmTokens, topic, unsubscribe, pathViews, useEventKey) => fsfn_removeTokensFromTopics(fsCall, fcmTokens, topic, unsubscribe, pathViews, useEventKey),
  sendCustomTokenEmail: (notificationData) => fsfn_sendCustomTokenEmail(fsCall, notificationData),
  sendEmail: (notificationData) => fsfn_sendEmail(fsCall, notificationData),
  sendFcmPayload: (fcmPayload, callback, callbackSelf) => sendFcmPayload(fsCall, database_fns, fcmPayload, callback, callbackSelf),
  sendLinkEmail: (notificationData) => fsfn_sendLinkEmail(fsCall, notificationData),
  sendNotificationByData: (notificationMethodType, notificationData, pathViews, tokens, token, topic, callback, logging, callbackSelf, itemKey, useEventKey) => fsfn_sendNotificationByData(fsCall, database_fns, notificationMethodType, notificationData, pathViews, tokens, token, topic, callback, logging, callbackSelf, itemKey, useEventKey),
  sendNotificationToSelf: (props) => sendNotificationToSelf(fsCall, props),
  sendScheduledNotifications_gcs_direct: () => fsfn_sendScheduledNotifications_gcs_direct(fsCall),
  sendSms: (data, logging, callback) => fsfn_sendSms(fsCall, data, logging, callback),
  subscribeToTopic: (token, topicKey, unsubscribe, itemKey, callback) => fsfn_subscribeToTopic(fsCall, token, topicKey, unsubscribe, itemKey, callback),
})

export function buildFcmPayload(tokens, topic, title, body, data = {}, icon, badge, url) {

  const payload = {
    notification: {
      title: title || "Notification Title",
      body: body || "Notification body text",
    },
    data: {
      title: title || "Notification Title",
      body: body || "Notification body text",
      url: url || '/',
      icon: icon || '/icons/favicon-me2.ico',
      badge: badge || '/icons/favicon-me2.ico',
      ...data,
    },
    tokens: tokens,
    topic: topic,
  };

  return payload
}

// export function buildFcmPayload(tokens, title, body, data = {}, icon, badge) {
//   return { 
//     data: {
//       title: title || "Notification Title",
//       body: body || "Notification body text", 
//     }, 
//     tokens
//   };
// }


/**
 * 
 * @param {object} data  
 */
const fsfn_subscribeToTopic = async (fsCall, token, topicKey, unsubscribe, itemKey, callback) => {
  try {
    const callData = {
      notificationFunctionType: notificationFunctionTypes.subscribeToTopic,
      token,
      topicKey,
      unsubscribe,
      showLogs: true,
      itemKey
    }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    callback && callback(response_data, { token, topicKey, unsubscribe, itemKey })
    return response_data
  } catch (error) {
    console.error('sendNotification_hourly - error', error)
  }
}

/**
 * 
 * @param {object} data  
 */
const fsfn_checkNotification_direct = async (testOnly) => {
  try {
    const callData = { testOnly: testOnly, showLogs: true }
    await callFunctionDirect('checkNotification_direct', callData)
  } catch (error) {
    console.error('sendNotification_hourly - error', error)
  }
}

/**
 * 
 * @param {object} data  
 */
const fsfn_sendScheduledNotifications_gcs_direct = async (fsCall) => {
  try {
    const data = {
      notificationFunctionType: notificationFunctionTypes.sendScheduledNotifications_gcs_direct,
      showLogs: true
    }
    const response_data = await callFsFunction(fsCall, data) // OK
    console.log('response_data', response_data)
    return response_data
  } catch (error) {
    console.error('fsfn_getClientTopics - error', error)
  }
}

/**
 * 
 * @param {object} data 
 * @deprecated
 */
const fsfn_getClientTopics = async (fsCall, data) => {
  try {
    data.notificationFunctionType = notificationFunctionTypes.getClientTopics
    const response_data = await callFsFunction(fsCall, data) // OK
    return response_data
  } catch (error) {
    console.error('fsfn_getClientTopics - error', error)
  }
}

/** sends a notifcation to the appUsers tokens
 * {notificationData, appUserAccess, paps_state, callback: handleShowNormal} */
const sendNotificationToSelf = async (fsCall, props) => {
  const { notificationData, appUserAccess, pathViews, callback, logging } = props
  return fsfn_sendNotificationByData(mainFunctions, notificationData, pathViews, appUserAccess.fcmTokens, null, null, callback, logging, appUserAccess._itemKey)
}

// dH4MhCSz_mWbikxMb_r_IF:APA91bEFoXes5qhzpL0egqIOyG9VKfQbuiBavWoS7FZfaru0KXITQCsSL_j6ElDxY7zr01TcbzIzKk27dsaX5LZXvCxG1KWt8xawEPdoIOFzVYh9U4vHbXU
// dH4MhCSz_mWbikxMb_r_IF:APA91bEFoXes5qhzpL0egqIOyG9VKfQbuiBavWoS7FZfaru0KXITQCsSL_j6ElDxY7zr01TcbzIzKk27dsaX5LZXvCxG1KWt8xawEPdoIOFzVYh9U4vHbXU
// dH4MhCSz_mWbikxMb_r_IF:APA91bEFoXes5qhzpL0egqIOyG9VKfQbuiBavWoS7FZfaru0KXITQCsSL_j6ElDxY7zr01TcbzIzKk27dsaX5LZXvCxG1KWt8xawEPdoIOFzVYh9U4vHbXU

// LOG dh7h43UspIJc4_IMBPPUen:APA91bEPJr-MCT3JEOWH57SlqAU5fSR30E9y-AYT2jP_dS719oFiSWNs1wnKCNSTUXgq1_PBTlkXPlqHWWFBbc47ucZReGh-DrrhrTWPLFH3uohIyH8CNYQ

const sendFcmPayload = async (fsCall, database_fns, fcmPayload, callback, callbackSelf) => {
  try {
    // background => messaging.onBackgroundMessage in firebase-messaging-sw.js
    // foreground => const unsubscribe = onMessage(mainMessaging, (payload) in AppNotificationsContext
    const callData = {
      notificationFunctionType: notificationFunctionTypes.sendFcmPayload,
      fcmPayload,
      showLogs: true,
      sendTypes: {
        withNotificatioOnly: false,
        withDataOnly: true,
        withBoth: false
      }
    }
    if (_allowNotificationSend) {
      const response_data = await callFsFunction(fsCall, callData) // OK   
      console.log('response_data', response_data)
      callback && updateNotificationsDirect(database_fns, pathViews, notificationData, response_data, callback)
      callbackSelf && callbackSelf(response_data, fcmPayload)
      return response_data
    } else {
      console.log('NS - sendNotificationSimple', callData)
    }
  } catch (error) {
    console.error('#sendNotificationSimple - error', error)
  }
}

/** sends a notifcation to the given tokens
 * {notificationData, appUserAccess, paps_state, callback: handleShowNormal} */
/**
 * 
 * @param {object} notificationData 
 * @param {string} pathViews 
 * @param {array} tokens 
 * @param {function} callback 
 * @param {object} _logging 
 * @param {function} callbackSelf 
 * @description sends a notifcation to the given tokens
 * @callback - sends a notifcation to the given tokens
 */
const fsfn_sendNotificationByData = async (fsCall, database_fns, notificationMethodType, notificationData, pathViews, tokens, token, topic, callback, _logging, callbackSelf, itemKey, useEventKey) => {
  try {

    const appKeys = {
      dev: fbAppConfigs.meetingevolution.dev.projectId,
      prod: fbAppConfigs.meetingevolution.prod.projectId,
    }

    const callData = {
      notificationFunctionType: notificationFunctionTypes.sendGenericPush,
      token: tokens ? tokens[0] : null,
      notificationType: 'data',
      notification: { ...notificationData },
      notificationMethodType,
      tokens,
      token,
      topic,
      itemKey,
      showLogs: true, //logging && logging.allowLogging && logging.logNotifications,
      pathViews,
      useEventKey,
      data: {
        ...notificationData,
        cn: 'match-notes',
        icon: `https://firebasestorage.googleapis.com/v0/b/${appKeys.dev}.appspot.com/o/FCMImages%2FDark%20Bell.png?alt=media&token=10b5d859-2f11-4d42-8d4d-d7d80b185ec4`
      }
    }

    if (_allowNotificationSend) {
      console.log('callData', callData)
      const response_data = await callFsFunction(fsCall, callData) // OK
      console.log('response_data', response_data)
      // const response_data = await fsCall(callData) // OK
      // const response_data = await callFsFunction(callData) // OK
      callback && updateNotificationsDirect(database_fns, pathViews, notificationData, response_data, callback)
      callbackSelf && callbackSelf(response_data)
      return response_data
    } else {
      console.log('NS - fsfn_sendNotificationByData', callData)
    }
  } catch (error) {
    console.error('#fsfn_sendNotificationByData - error', error)
  }
}

/**
 * 
 * @param {object} notificationData 
 * @returns response_data {success, result, error}
 */
const fsfn_sendEmail = async (fsCall, notificationData) => {
  try {
    notificationData.notificationFunctionType = notificationFunctionTypes.sendCustomEmail
    const response_data = await callFsFunction(fsCall, notificationData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/**
 * 
 * @param {object} notificationData 
 * @returns response_data {success, result, error}
 */
const fsfn_sendCustomTokenEmail = async (fsCall, notificationData) => {
  try {
    console.log('fsfn_sendCustomTokenEmail', notificationData)
    notificationData.notificationFunctionType = notificationFunctionTypes.sendCustomTokenEmail
    const response_data = await callFsFunction(fsCall, notificationData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}
/**
 * 
 * @param {object} notificationData 
 * @returns response_data {success, result, error}
 */
const fsfn_sendLinkEmail = async (fsCall, notificationData) => {
  try {
    notificationData.notificationFunctionType = notificationFunctionTypes.sendLinkEmail
    const response_data = await callFsFunction(fsCall, notificationData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} data 
 * @param {object} logging 
 * @returns response_data {success, result, error}
 */
const fsfn_sendSms = async (fsCall, data, logging, callback) => {
  try {
    const { to, text } = data
    const _showLogs = logging && logging.allowLogging && logging.logSms
    const sendData = { notificationFunctionType: notificationFunctionTypes.sendSms, to: to, text, showLogs: true }
    const response_data = await callFsFunction(fsCall, sendData) // OK   
    callback && callback(response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} appProfileData 
 * @param {boolean} unsubscribe 
 * @param {object} logging 
 * @returns response_data {success, result, error}
 */
const fsfn_addTopicGroups = async (fsCall, appProfileData, unsubscribe, logging) => {
  try {
    const data = { notificationFunctionType: notificationFunctionTypes.addTopicGroups, appProfileData, unsubscribe, showLogs: logging && logging.allowLogging && logging.logNotificationTopics }
    const response_data = await callFsFunction(fsCall, data) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/**
 * Add the fcmTokens in to the topic
 * @param {array} fcmTokens 
 * @param {string} topic 
 * @param {boolean} unsubscribe 
 * @returns response_data {success, result, error}
 */
const fsfn_addTopicToFcmTokens = async (fsCall, fcmTokens, topic, unsubscribe, pathViews, useEventKey) => {
  try {
    const data = { notificationFunctionType: notificationFunctionTypes.addTopicToFcmTokens, fcmTokens, topic, unsubscribe, pathViews, useEventKey, showLogs: true }
    const response_data = await callFsFunction(fsCall, data) // OK
    console.log('response_data', response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_removeTokensFromTopics = async (fsCall, fcmTokens, topic, unsubscribe, pathViews, useEventKey) => {
  try {
    const data = {
      notificationFunctionType: notificationFunctionTypes.removeTokensFromTopics,
      fcmTokens,
      topic,
      unsubscribe,
      pathViews,
      useEventKey,
      showLogs: true
    }
    const response_data = await callFsFunction(fsCall, data) // OK
    console.log('response_data', response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/** Sends a notification to a topic */
// export const sendNotification_topic = async (notificationData, appUserAccess, paps_state) => {
//   const { rootPaths } = paps_state ?? {}
//   const { events } = rootPaths ? rootPaths : {}
//   let topicPath = events ? events.replace(/\//g, '_') : null
//   const { topicOriginGroup, topicOriginGroupKey } = notificationData
//   topicPath += topicOriginGroup + '_' + topicOriginGroupKey
//   const sendProps = appUserAccess ? { profileId: appUserAccess.profileId } : {}
//   const _notificationData = getNotificationData(notificationTypes.notification, {}, { topic: topicPath }, { title, body })
//   const result = await fsfn_sendNotification(sendProps, _notificationData, pathViews)
//   return result
// }


// Payment Initiated
// Your payment has been submitted.
// Your confirmation number is 1156833167
// Account Paid:	0017971496
// Amount Due:
// $520.76
// Due Date:
// Sep 01, 2024
// Card Type:	VISA
// Card Info:	********7639 Visa Debit
// Name on Card:	PHILIP A OKEEFFE
// Billing Address:	2040 HAMPSTEAD DR
// PITTSBURGH PA 15235
// Total Amount Paid:	$520.76
// Pay Date:	Sep 1, 2024